import { createFileRoute } from '@tanstack/react-router';

import { RecordScreen } from '~/features/record/record-screen';
import { recordSearchSchema } from '~/features/record/record-search-schema';

/**
 * One entry, in the right panel beside its record's table (web-redesign-05 Decided 6).
 * The same component as the record route, so the table beside the panel is
 * the one that was on screen.
 */
export const Route = createFileRoute('/_app/records/$recordId/entries/$entryId/')({
  validateSearch: recordSearchSchema,
  component: RecordScreen,
});
